export enum COOKIE_CONSENT {
  Init = "init",
  Visible = "visible",
  Consent = "consent",
  Denied = "denied"
}
